import React, { ComponentProps } from 'react';
import { ContentList, ContentListItem } from '../../../_lib/components/ContentList';
import { murmurhash } from '../../../lib/js/hash';
import { ContentHeadline } from '../../../_lib/components/ContentHeadline';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useAppContext } from '../../../contexts/AppContext/AppContext';
import { ContentCard } from '../../../_lib/components/ContentCard';
import { asView } from '../../../_lib/ViewFetcher';
import { ContentCardName } from '../../../_lib/components/ContentCard/partials/ContentCardName';

type RoleSpecificAreaGroup = {
  name: string;
  group: string;
};

type RoleSpecificAreaGroupsDefaultProps = {
  areaGroups: RoleSpecificAreaGroup[];
};

type RoleGroupsType = Record<string, RoleSpecificAreaGroup[]>;

const categorizeByGroup = (areaGroups: RoleSpecificAreaGroup[]): [RoleGroupsType, string[]] => {
  const order: string[] = [];
  const roleGroups: RoleGroupsType = {};
  areaGroups.forEach((areaGroup: RoleSpecificAreaGroup) => {
    const group = roleGroups[areaGroup.group] || [];
    group.push(areaGroup);
    if (!order.includes(areaGroup.group)) {
      order.push(areaGroup.group);
    }
    roleGroups[areaGroup.group] = group;
  });
  return [roleGroups, order];
};

function RoleSpecificAreaGroupsDefault({ areaGroups }: RoleSpecificAreaGroupsDefaultProps) {
  const { editModeInfo } = useAppContext();
  const { active } = editModeInfo;
  const { t } = useSonTranslation('AreaGroups');

  if (areaGroups?.length === 0) {
    return null;
  }

  const [roleGroups, order]: [RoleGroupsType, string[]] = categorizeByGroup(areaGroups);
  return (
    <div className="role-specific-area-groups">
      {!active && (
        <div className="role-specific-area-groups__headline">
          <ContentHeadline title={t('roleSpecificAreaGroups.blockTitle')} hierarchy={3} />
        </div>
      )}

      {order.map(value => {
        return (
          <div key={value} className="role-specific-area-groups__role-group-default">
            <ContentList key={murmurhash(value)}>
              {roleGroups[value].map((roleGroup: RoleSpecificAreaGroup) => (
                <ContentListItem key={murmurhash(roleGroup)}>
                  <ContentCard>
                    <ContentCardName>{roleGroup.name}</ContentCardName>
                  </ContentCard>
                </ContentListItem>
              ))}
            </ContentList>
          </div>
        );
      })}
    </div>
  );
}

export const RoleSpecificAreaGroupsDefaultView = asView(RoleSpecificAreaGroupsDefault);
export type RoleSpecificAreaGroupsDefaultView = ComponentProps<typeof RoleSpecificAreaGroupsDefaultView>;
